const antiforgeryHeader = {
  headers: {
    "X-CSRF": "1"
  }
};

//console.log("### Hello checking session")
async function checkSession() {
  const response = await fetch("/bff/user", antiforgeryHeader);

  // console.log("##CheckSession response", response);
  if (response.status == 401) {
    console.log("The user was unauthorised:login");
    window.top.location.href = `/bff/login?returnUrl=${window.top.location.pathname}`;
  }

  //console.log("##Session about to get the userdata.");
  const user = await response.json();
  const expires = user.filter(c => c.type == 'bff:session_expires_in')[0];
  // console.log("##Session expires: ", expires, expires.value);
  if (expires.value < 90) {
    console.log("The session has expired:login");
    const logoutUrl = user.filter(c => c.type == 'bff:logout_url')[0];
    console.log("The logout url is: ", logoutUrl.value);
    window.top.location.href = logoutUrl.value;
  }
}

setInterval(checkSession, 60000);
